export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7294.96c868f4.jpg";